<template lang="html">
  <div>

    <!-- Error messages -->
    <!--<panel-alert-->
      <!--type="error"-->
      <!--:show="isError"-->
      <!--:msg="error"-->
      <!--v-on:hide-alert="hideError"-->
    <!--/>-->

    <!-- Loading indicator -->
    <template v-if="loading">
      <loading flat :message="false" />
    </template>

    <!-- Loading error message & reload button -->
    <!--<reinit-widget v-else-if="onLoadError" v-on:reinit="init()" :msg="onLoadErrorMsg" />-->

    <template v-else>
      <el-form size="mini" ref="kanbanForm">
        <el-form-item label="Канбан-доска" prop="board">
          <el-select v-model="boardId" placeholder="Выберите доску для подключения" @change="toSave = true">
            <el-option
                       v-for="board in boards" :key="board.id"
                       :label="board.name"
                       :value="board.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" @click="save()" size="small" :disabled="!toSave">Сохранить</el-button>
      </el-form>
    </template>

  </div>
</template>

<script>

import apiKanban from '@/apps/bpm/kanban/api/settings/api.js'
import { mapState, mapMutations } from 'vuex'



/**
 *
 *
 */
export default {

  props: {

    //
    modelId: {
      type: String,
      required: false,
      default: null
    },
  },

  /**
   *
   *
   */
  data() {

    return {

      loading: false,

      toSave: false,

      boards: [],

      noBoard: {
        id: null,
        name: 'Без доски'
      },

      board: null,

      boardId: null,

      model: null
    }
  },

  /**
   *
   *
   */
  watch: {

    /**
     * Статус избранного.
     *
     */
    modelId: {

      handler( modelId ) {

        this.model = modelId ? this.items[ modelId ] : null
        this.boardId = this.model.board_id
      },

      // Необходимо для инициализации значения по умолчанию
      immediate: true,

      // Необходимо для отслеживания всех свойств объекта на всю глубину
      deep: true
    }
  },

  /**
   *
   *
   */
  computed: {
    ...mapState( 'bpm/designer/process/', [ 'items' ] ),
  },

  /**
   *
   *
   */
  created: function() {

    // Инициализация.
    this.init()
  },

  /**
   *
   *
   */
  methods: {

    ...mapMutations( 'bpm/designer/process', [ 'updateItem' ] ),

    /**
     *
     *
     */
    init() {

      this.loading = true
      this.getBoards()
    },

    /**
     *
     *
     */
    save() {

      this.toSave = false

      if ( this.boardId ) {
        this.setBoard()
      }
      else {
        this.resetBoard()
      }
    },

    /**
     *
     *
     */
    getBoards() {

      return apiKanban.boards()
        .then( data => {

          this.loading = false
          this.boards = data.list.public.boards.concat( data.list.private.boards )
          this.boards.unshift( this.noBoard )
        } )
        .catch( ( error ) => {

          console.error( error )
        } )
    },

    /**
     *
     *
     * @returns {Promise<T>}
     */
    setBoard() {

      return apiKanban.setBoard( this.modelId, this.boardId )
        .then( () => {

          this.model.board_id = this.boardId
          this.updateItem( this.model );
        } )
        .catch( ( error ) => {

          console.error( error )
        } )
    },

    /**
     *
     *
     * @returns {Promise<T>}
     */
    resetBoard() {

      return apiKanban.resetBoard( this.modelId )
        .then( () => {

          this.model.board_id = null
          this.updateItem( this.model );
        } )
        .catch( ( error ) => {

          console.error( error )
        } )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/apps/bpm/designer/components/panel/Kanban.vue